
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=name,description,duration,basic_pay,transport_allowance_amount' : ''
    // pagination
    const page = data.page ? '&page=' + data.page : ''
    return axios.get(process.env.API_ENDPOINT + '/class-type?token=' + VueCookies.get('token') + page + search + limit)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/class-type?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/class-type/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/class-type/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/class-type/' + id + '?token=' + VueCookies.get('token'))
  },
  bulkDelete (ids) {
    return axios.post(process.env.API_ENDPOINT + '/class-type/bulk-delete?token=' + VueCookies.get('token'), { ids })
  }
}



// WEBPACK FOOTER //
// ./src/store/api/class-types.js